import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EllipsisMenuItem } from '@gainsystems/gains-ui-commons';

/**
 * Interface for period comparison data
 */
export interface PeriodComparisonData {
  /** Percentage change vs previous period */
  versusPercent: number | null;
  /** Previous period value */
  previousPeriodValue: number | string | null;
  /** Formatted versus percentage display */
  formattedVersusPercent: string;
  /** Formatted previous period value display */
  formattedPreviousPeriodValue: string;
  /** CSS class for versus percentage styling (e.g., delta--positive, delta--negative) */
  versusPercentClass: string;
}

@Component({
  selector: 'enhanced-kpi-widget',
  standalone: false,
  templateUrl: './enhanced-kpi-widget.component.html',
  styleUrl: './enhanced-kpi-widget.component.scss'
})
export class EnhancedKpiWidgetComponent {
  @Input() widgetTitle = '';
  @Input() value: number | string = '--';
  @Input() unit = '';
  @Input() widthClass = 'extra-chart-small';
  @Input() valueClass = ''; // CSS classes for the KPI value
  @Input() menuItems: EllipsisMenuItem[] = [];
  @Input() widgetId = '';
  @Input() hasData = true;
  @Input() comparisonData: PeriodComparisonData | null = null; // Period comparison data
  @Input() noDataValue = '—'; // Value to display when no data
  @Output() changeEvent = new EventEmitter<string>();

  Math = Math;

  handleMenuAction(action: string): void {
    this.changeEvent.emit(action);
  }

  get hasComparisonData(): boolean {
    return this.comparisonData !== null;
  }

  getExactValueTitle(): string {
    if (!this.hasData) {
      return 'No data available';
    }
    if (typeof this.value === 'number') {
      return `Exact value: ${this.value.toFixed(3)} ${this.unit}`;
    }
    return 'No data available';
  }
}
